module.exports = __webpack_public_path__ + "img/Customization-with-high-flexibility.f816de85.png";